import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    position: relative;
    width: 100%;
    max-width: 420px;
    border-radius: 28px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.basic.white};
    box-shadow: 0 20px 45px ${({ theme }) => theme.colors.neutral.neutral90};
`;

export const Header = styled.div`
    position: relative;
    height: 150px;
    overflow: hidden;
    background: linear-gradient(135deg, ${({ theme }) => theme.colors.tertiary.tertiary50} 0%, ${({ theme }) => theme.colors.tertiary.tertiary30} 100%);

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-image: radial-gradient(rgba(255, 255, 255, 0.16) 1.5px, transparent 1.5px);
        background-size: 18px 18px;
        opacity: 0.6;
    }
`;

export const LogoWrapper = styled.div`
    position: absolute;
    top: 18px;
    left: 20px;
    z-index: 1;
    opacity: 0.95;
`;

export const Blob = styled.span`
    position: absolute;
    top: -70px;
    right: -50px;
    width: 190px;
    height: 190px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.secondary.secondary50};
    opacity: 0.45;
    filter: blur(35px);
`;

export const Wave = styled.svg`
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 46px;
`;

export const AvatarRing = styled.div`
    position: absolute;
    left: 50%;
    top: 90px;
    transform: translateX(-50%);
    width: 120px;
    height: 120px;
    padding: 5px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.basic.white};
    box-shadow: 0 8px 20px ${({ theme }) => theme.colors.neutral.neutral90};
    z-index: 1;
`;

export const Avatar = styled.div<{ image?: string | null }>`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.tertiary.tertiary95};
    background-image: ${({ image }) => (image ? `url(${image})` : 'none')};
    background-size: cover;
    background-position: top center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 76px 32px 36px;
`;

export const AgencyBadge = styled.span`
    display: inline-flex;
    margin-top: 10px;
    padding: 4px 16px;
    border-radius: 20px;
    background-color: ${({ theme }) => theme.colors.secondary.secondary95};
    color: ${({ theme }) => theme.colors.secondary.secondary40};
`;

export const Divider = styled.span`
    width: 56px;
    height: 3px;
    margin: 26px 0 22px;
    border-radius: 4px;
    background: linear-gradient(90deg, ${({ theme }) => theme.colors.tertiary.tertiary50}, ${({ theme }) => theme.colors.secondary.secondary50});
`;

export const InfoList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
`;

export const LinkInfo = styled.a`
    display: flex;
    align-items: center;
    gap: 14px;
    width: 100%;
    padding: 10px 14px;
    border-radius: 16px;
    color: ${({ theme }) => theme.colors.neutral.neutral10};
    transition: background-color 0.3s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.neutral.neutral96};
    }
`;

export const IconBadge = styled.span<{ variant: 'blue' | 'orange' }>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;

    ${({ variant, theme }) =>
        variant === 'blue'
            ? css`
                  background: linear-gradient(135deg, ${theme.colors.tertiary.tertiary50}, ${theme.colors.tertiary.tertiary40});
              `
            : css`
                  background: linear-gradient(135deg, ${theme.colors.secondary.secondary50}, ${theme.colors.secondary.secondary40});
              `}
`;

export const DownloadButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    margin-top: 28px;
    padding: 14px 24px;
    border: none;
    border-radius: 50px;
    background: linear-gradient(90deg, ${({ theme }) => theme.colors.tertiary.tertiary50}, ${({ theme }) => theme.colors.secondary.secondary50});
    color: ${({ theme }) => theme.colors.basic.white};
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 14px 26px rgba(0, 0, 0, 0.2);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const InfoText = styled.span`
    display: flex;
    flex-direction: column;
    overflow: hidden;

    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;
